import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { ProcessingStepModal } from './ProcessingStepModal';

export const ProcessingStepContainer = observer((): ReactElement => {
  const store = useInjection(IImportAnnotationsStore.$);

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.Processing;

  return <ProcessingStepModal show={isCurrentStep} />;
});
